import type { ContactPreference } from '@gql/graphql';

export interface ContactPreferencesData {
  mode: 'edit' | 'view';
  onChangeContactPreferenceClick: (contactPreferences: ContactPreference[], value: boolean) => void;
  emails: ContactPreferenceItem[];
}

export interface ContactPreferencesProps extends ContactPreferencesData {}

export interface ContactPreferenceItem {
  title: string;
  items: { content: string; items: ContactPreference[]; isDisabled?: boolean }[];
}
